import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// auditLogging-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  clearAuditLogging(store) {
    store.commit('clearAuditLogging')
  },
  async setAuditLoggings(store, payload) {
    store.state.auditLoggings = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 600
    }
    const data = {
      header,
      data: [
        {
          displayDateTimes: [
            {
              startDateTime: payload.startDateTime,
              endDateTime: payload.endDateTime
            }
          ],
          pageNo: payload.pageNo,
          count: 20,
          searchWord: payload.searchWord
        }
      ]
    }
    var response = await Vue.http.post(URL + '/v2/admin/log/list', data, config)
    // 成功
    store.commit('setAuditLoggings', response)
  },

  searchvalue(store, payload) {
    store.commit('searchvalue', payload)
  },
  searchStartDateTime(store, payload) {
    store.commit('searchStartDateTime', payload)
  },
  searchEndDateTime(store, payload) {
    store.commit('searchEndDateTime', payload)
  },
  changeFindAuditLoggings(store, payload) {
    store.commit('changeFindAuditLoggings', payload)
  },
  updateSelectedLogList(store, payload) {
    store.commit('updateSelectedLogList', payload)
  },
  clearSelectedLogList(store) {
    store.commit('clearSelectedLogList')
  },
  async setExportData(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 600
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: {
          startDateTime: payload.startDateTime,
          endDateTime: payload.endDateTime,
          pageNo: pageNo,
          count: count,
          searchWord: payload.searchWord
        }
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/log/export',
        data,
        config
      )

      const size = response.data['data'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }
    // 成功
    // 追加後の処理
    store.commit('setExportData', margeData)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auditLoggingModules/actions.js